export default __webpack_public_path__ + "acb0f9c56c25b012d6716735fa8886e0.svg";